import { render, staticRenderFns } from "./CInputWithSelect.vue?vue&type=template&id=196ca5ab&scoped=true&"
import script from "./CInputWithSelect.vue?vue&type=script&lang=ts&"
export * from "./CInputWithSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CInputWithSelect.vue?vue&type=style&index=0&id=196ca5ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ca5ab",
  null
  
)

export default component.exports